import { AdminAnalyticsService } from '@/services';

export type {
  AgentComparisonResponse,
  AgentComparisonRow,
  AgentTrendResponse,
} from '@/services';

export type GetAgentComparisonParams = {
  campaignId: string;
  startedFrom?: string | null;
  startedTo?: string | null;
};

export const getAgentComparison = ({
  campaignId,
  startedFrom,
  startedTo,
}: GetAgentComparisonParams) =>
  AdminAnalyticsService.getAgentComparisonApiAdminAnalyticsAgentComparisonGet(
    campaignId,
    startedFrom,
    startedTo
  );

export type GetAgentTrendParams = GetAgentComparisonParams & {
  granularity?: string | null;
};

export const getAgentComparisonTrend = ({
  campaignId,
  startedFrom,
  startedTo,
  granularity,
}: GetAgentTrendParams) =>
  AdminAnalyticsService.getAgentComparisonTrendApiAdminAnalyticsAgentComparisonTrendGet(
    campaignId,
    startedFrom,
    startedTo,
    granularity
  );
